import type {ContentType} from '@ca.vmedia.tv/swagger-api';
import type {ContentItemProps} from '@ca.vmedia.tv/domains';

export class GetItemPropertiesRequest {
    constructor(
        readonly ids: Array<number> = [],
        readonly type: ContentType | null = null,
        readonly props: Array<ContentItemProps> = [],
    ) {}
}
